<h2 mat-dialog-title>{{ "commonImportConfirmDialog.confirmation" | translate }}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{ "commonImportConfirmDialog.message" | translate }}</p>
  <mat-list>
    <mat-list-item>
      <p>{{ data.fileName }}</p>
    </mat-list-item>
  </mat-list>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary" type="button">{{ "commonImportConfirmDialog.no" | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="confirm()">{{ "commonImportConfirmDialog.yes" | translate }}</button>
  </mat-dialog-actions>
</div>
